import { QueryConfig } from "store/utils/query-config";

export const conversationsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-metaData.lastMessage.timestamp"],
  },
};
